export const FETCH_PREMIER_COLLECTION_SHOP =
  "premierCollectionShop/FETCH_PREMIER_COLLECTION_SHOP";
export type FETCH_PREMIER_COLLECTION_SHOP =
  typeof FETCH_PREMIER_COLLECTION_SHOP;

export const SET_PREMIER_COLLECTION_SHOP_RESULTS =
  "premierCollectionShop/SET_PREMIER_COLLECTION_SHOP_RESULTS";
export type SET_PREMIER_COLLECTION_SHOP_RESULTS =
  typeof SET_PREMIER_COLLECTION_SHOP_RESULTS;

export const SET_PREMIER_COLLECTION_SHOP_CALL_STATE_FAILED =
  "premierCollectionShop/SET_PREMIER_COLLECTION_SHOP_CALL_STATE_FAILED";
export type SET_PREMIER_COLLECTION_SHOP_CALL_STATE_FAILED =
  typeof SET_PREMIER_COLLECTION_SHOP_CALL_STATE_FAILED;

export const SELECT_ROOM_TYPE = "premierCollectionShop/SELECT_ROOM_TYPE";
export type SELECT_ROOM_TYPE = typeof SELECT_ROOM_TYPE;

export const ACKNOWLEDGE_PREMIER_COLLECTION_SHOP_FAILURE =
  "premierCollectionShop/ACKNOWLEDGE_PREMIER_COLLECTION_SHOP_FAILURE";
export type ACKNOWLEDGE_PREMIER_COLLECTION_SHOP_FAILURE =
  typeof ACKNOWLEDGE_PREMIER_COLLECTION_SHOP_FAILURE;

export const SELECT_LODGING = "premierCollectionShop/SELECT_LODGING";
export type SELECT_LODGING = typeof SELECT_LODGING;

export const SET_PREMIER_COLLECTION_SHOP_PROGRESS =
  "premierCollectionShop/SET_PREMIER_COLLECTION_SHOP_PROGRESS";
export type SET_PREMIER_COLLECTION_SHOP_PROGRESS =
  typeof SET_PREMIER_COLLECTION_SHOP_PROGRESS;

export const SET_IS_FROM_HOTEL_AVAILABILITY =
  "premierCollectionShop/SET_IS_FROM_HOTEL_AVAILABILITY";
export type SET_IS_FROM_HOTEL_AVAILABILITY =
  typeof SET_IS_FROM_HOTEL_AVAILABILITY;

export const SET_CACHE_LODGING_TOKEN_RESPONSE =
  "premierCollectionShop/SET_CACHE_LODGING_TOKEN_RESPONSE";
export type SET_CACHE_LODGING_TOKEN_RESPONSE =
  typeof SET_CACHE_LODGING_TOKEN_RESPONSE;

export const SET_IS_FROM_PREMIUM_OFFERS =
  "premierCollectionShop/SET_IS_FROM_PREMIUM_OFFERS";
export type SET_IS_FROM_PREMIUM_OFFERS = typeof SET_IS_FROM_PREMIUM_OFFERS;

export const SET_PERSISTENT_LODGING_TRACKING_PROPERTIES =
  "premierCollectionShop/SET_PERSISTENT_LODGING_TRACKING_PROPERTIES";
export type SET_PERSISTENT_LODGING_TRACKING_PROPERTIES =
  typeof SET_PERSISTENT_LODGING_TRACKING_PROPERTIES;

export const SET_SELECTED_LODGING_IS_FAVORITED =
  "premierCollectionShop/SET_SELECTED_LODGING_IS_FAVORITED";
export type SET_SELECTED_LODGING_IS_FAVORITED =
  typeof SET_SELECTED_LODGING_IS_FAVORITED;

export const SET_HOTEL_DETAILS_ENTRY_SOURCE =
  "premierCollectionShop/SET_HOTEL_DETAILS_ENTRY_SOURCE";
export type SET_HOTEL_DETAILS_ENTRY_SOURCE =
  typeof SET_HOTEL_DETAILS_ENTRY_SOURCE;

export const SET_ALLOWED_PAY_LATER_LODGING_IDS =
  "premierCollectionShop/SET_ALLOWED_PAY_LATER_LODGING_IDS";
export type SET_ALLOWED_PAY_LATER_LODGING_IDS =
  typeof SET_ALLOWED_PAY_LATER_LODGING_IDS;

export const CHECK_LIFESTYLE_ELIGIBILITY =
  "premierCollectionShop/CHECK_LIFESTYLE_ELIGIBILITY";
export type CHECK_LIFESTYLE_ELIGIBILITY = typeof CHECK_LIFESTYLE_ELIGIBILITY;

export const SET_LIFESTYLE_ELIGIBILITY =
  "premierCollectionShop/SET_LIFESTYLE_ELIGIBILITY";
export type SET_LIFESTYLE_ELIGIBILITY = typeof SET_LIFESTYLE_ELIGIBILITY;